/**
 * Finds the first metric (in yAxisTitle family/metric order) that has at least one
 * non-null/non-undefined value across all data points. Falls back to '0_0' when every
 * metric is entirely empty, so callers always get a defined metric id to render.
 */
export function findFirstAvailableMetric(
    data: Array<{ y: Array<Array<number | null | undefined>> }> | undefined,
    yAxisTitle: string[][] | undefined,
): string {
    if (!Array.isArray(yAxisTitle)) return '0_0';

    for (let familyIndex = 0; familyIndex < yAxisTitle.length; familyIndex++) {
        const family = yAxisTitle[familyIndex];
        if (!Array.isArray(family)) continue;
        for (let metricIndex = 0; metricIndex < family.length; metricIndex++) {
            const hasValue = (data ?? []).some((dp) => dp.y?.[familyIndex]?.[metricIndex] != null);
            if (hasValue) return `${familyIndex}_${metricIndex}`;
        }
    }

    return '0_0';
}

/**
 * Finds the index of the first yAxisTitle family that has at least one metric with a
 * non-null/non-undefined value across all data points. Falls back to family 0 when every
 * family is entirely empty.
 */
export function findFirstAvailableFamilyIndex(
    data: Array<{ y: Array<Array<number | null | undefined>> }> | undefined,
    yAxisTitle: string[][] | undefined,
): number {
    if (!Array.isArray(yAxisTitle)) return 0;

    for (let familyIndex = 0; familyIndex < yAxisTitle.length; familyIndex++) {
        const family = yAxisTitle[familyIndex];
        if (!Array.isArray(family)) continue;
        const hasValue = family.some((_, metricIndex) =>
            (data ?? []).some((dp) => dp.y?.[familyIndex]?.[metricIndex] != null),
        );
        if (hasValue) return familyIndex;
    }

    return 0;
}
